import React from "react";
import styled from "styled-components";
import Slider from "react-slick";
import HomeItemDescriptionTags from "../../../layouts/Home/HomeElements/HomeItemDescriptionTags";
import {BigSpinner} from "../Loading";
import PrevArrow from "../Arrows/PrevArrow";
import NextArrow from "../Arrows/NextArrow";
import {KeyboardArrowLeft, KeyboardArrowRight, PlaylistAdd} from "@material-ui/icons";
import {IconButton} from "@material-ui/core";
import {checkIfMobile} from "../../../api-client/core/authentication/utils";
import localization from "../../../config/localization";
import {Tooltip} from "@material-ui/core/index";
import "layouts/Home/Home.css";

export const WorkContainer = ({ title, children }) => {
  return (
    <React.Fragment>
      <Title>{title}</Title>
      <InnerContainer>{children}</InnerContainer>
    </React.Fragment>
  );
};

const sliderSettings = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  initialSlide: 0,
  prevArrow: <PrevArrow overrideStyle={{transform: `translate(0, -${window.innerWidth < 1300 ? 155 : 130}%)`, left: "-35px", color: "#00000099"}}/>,
  nextArrow: <NextArrow overrideStyle={{transform: `translate(0, -${window.innerWidth < 1300 ? 155 : 130}%)`, right: "-35px", color: "#00000099"}}/>,
  responsive: [
    {
      breakpoint: 1500,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 960,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        initialSlide: 3
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false
      }
    }
  ]
};

export const Carousel = ({ items, renderItem, onItemClick, tags, onSelectedTagChanged, onAddToPlaylist, showAddToPlaylist }) => (
  <section style={{ textAlign: "center", width: "100%", padding:"0 1%", margin: "auto", position: "relative", float: "left" }}>
    {items.length > 0 && (
      <Slider
        style={{width: "100%"}}
        {...sliderSettings}>
        {items.map((item, key) => (
          <div key={key}>
            <div
              style={{ padding: "5px", cursor: "pointer" }}
              onClick={() => onItemClick({...item, itemIndex: key})}
            >
              <CarouselItem className="category-item">
                {showAddToPlaylist &&
                <div className="album-fav" style={{display: "none"}}>
                  <Tooltip placement="bottom" title={localization.get("add_to_playlist")}>
                    <div className="home-elements-add-to-playlist-button" style={{top: 5}}>
                      <IconButton onClick={(e) => {
                        e.stopPropagation()
                        onAddToPlaylist(item, 'contentCreation')
                      }} style={{height: 50, width: 50}}>
                        <PlaylistAdd style={{fontSize: "25px", color: "#0000008a", marginLeft: 4}}/>
                      </IconButton>
                    </div>
                  </Tooltip>
                </div>
                }
                {renderItem(item)}
              </CarouselItem>
              <div
                style={{
                  width: "100%",
                  textAlign: "center",
                  margin: "10px 0px",
                  color: "black"
                }}
              >
                {item.title}
              </div>
            </div>
          </div>
        ))}
      </Slider>
    )}
  </section>
);

export const SelectedWork = ({ item, renderItem, showSpinner, showArrows = false, onPrevArrow, onNextArrow, disablePrev, disableNext}) => (
  <section style={{ marginTop: "90px", textAlign: "center" }}>
    {showSpinner && <BigSpinner />}
    {item &&
      <div style={{ display: showSpinner ? "none" : "block" }}>
        <div style={{display: "flex", minHeight: 500}}>
          {showArrows &&
          <IconButton style={{alignSelf: "center"}} onClick={onPrevArrow} disabled={disablePrev}>
            <KeyboardArrowLeft style={{height: "2.5rem", width: "2.5rem"}}/>
          </IconButton>
          }
        <div
          style={{
            backgroundColor: "white",
            padding: "5px",
            maxWidth: "800px",
            margin: "auto",
            position: "relative",
            display: "inline-block",
            minWidth: checkIfMobile() ? 200 : 600,
            minHeight: checkIfMobile() ? 200 : 400
          }}
        >
          {renderItem(item)}
        </div>
          {showArrows &&
          <IconButton style={{alignSelf: "center"}} onClick={onNextArrow} disabled={disableNext}>
            <KeyboardArrowRight style={{height: "2.5rem", width: "2.5rem"}}/>
          </IconButton>
          }
        </div>
        <h2 style={{
          fontWeight: "bold",
          color: "black",
          fontSize: "2em",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}>{item.title}</h2>
        {item.description && <p>{item.description}</p>}
      </div>
    }
  </section>
);

const Title = styled.h4`
  font-weight: bold;
  color: white;
  margin: 30px 0;
  font-size: 1.7em;
 
`;

const InnerContainer = styled.section`
  //background-color: #ffffffc9;
  background-color: rgb(255, 255, 255);
  min-height: 100px;
  float: left;
  // border-bottom-left-radius: 30px;
  // border-bottom-right-radius: 30px;
  padding: 10px;
  width: 100%;
  @media (min-width: 479px) {
    padding: 10px 40px 40px 40px;
  }
`;

const CarouselItem = styled.div`
  background-color: white;
  height: 0;
  overflow: hidden;
  padding-top: calc(591.44 / 1127.34 * 100%);
  position: relative;
  &:hover {
    box-shadow: 0 0 5px 0 dimgray;
    display: block!important;
  }
`
